export default __webpack_public_path__ + "static/media/i.f8c0c545.svg";